import { FeaturePermissions, Pages } from "@vviinn/user-managment-client-ts";

const nameIsEqual = (name: string) => (feature: FeaturePermissions) =>
  feature.name === name;

export const isPermitted = (
  permissions: FeaturePermissions[],
  permission: string,
): boolean => {
  const [name, feature, action] = permission.split(":");
  const findName = nameIsEqual(name);
  const targetPermission = permissions.find(findName);
  if (targetPermission === undefined) return false;
  const targetFeature = targetPermission.features[feature];
  if (targetFeature === undefined) return false;
  return targetFeature.includes(action);
};

// Only global-tier roles get the platform-wide users page.
export const isGlobalRole = (pages: Pages["value"]) => pages.includes("users");
